import { classNames } from '../util';

interface Props {
  connected: boolean;
}

export function ConnectionDot({ connected }: Props) {
  return (
    <div className="conn" aria-live="polite">
      <span className={classNames('conn-dot', connected ? 'is-on' : 'is-off')} />
      <span className="conn-label">{connected ? 'live' : 'offline'}</span>
    </div>
  );
}
